import DebtSalesStatistic from "./DebtSalesStatistic";
import DebtSalesList from "./DebtSalesList";

const DebtSalesPage = () => {
  return (
    <>
      <DebtSalesStatistic />
      <DebtSalesList />
    </>
  );
};

export { DebtSalesPage };
